import store from '@/store'
export default async (to, from, next) => {
  /**
   * authorityIdを取得し、
   * 条件を満たしていない場合はhomeにリダイレクトする
   */

  if (!store.getters['User/authority'].id)
    await store.dispatch('User/getUserInfoFromApi')
  const { id } = store.getters['User/authority']

  if (to.meta.permissions && to.meta.permissions.includes(id)) {
    next()
  } else {
    next('/')
  }
}
